module.exports = __webpack_public_path__ + "img/reportTxt.608a8cfc.png";